// Este componente puede moverse a src/features/servicios/Serviciospages.jsx para modularizar.
import "./serviciospages.css";

const servicios = [
	{
		titulo: "Seguimiento Personalizado",
		descripcion: [
			"Control del progreso semanal de cada participante",
			"Registro de fotos de tus comidas diarias",
			"Fotos del cuerpo desde el inicio del reto hasta el final",
			"Grupo de WhatsApp para consultas y apoyo",
			"Ficha personal de cada participante",
		],
		imagen: "/images/servicios/servicios1.webp",
	},
	{
		titulo: "Reto de Alimentación",
		descripcion: [
			"Pérdida de peso saludable",
			"Manejo del estrés",
			"Balance hormonal",
			"Logra tus objetivos en solo 30 días",
		],
		imagen: "/images/servicios/servicios2.webp",
	},
	{
		titulo: "Reto Fitness",
		descripcion: [
			"Plan de alimentación y entrenamiento personalizado",
			"6 semanas",
			"Ponte en forma",
			"Quema grasas",
			"Siéntete genial",
		],
		imagen: "/images/servicios/servicios3.webp",
	},
	{
		titulo: "Clases de Funcional al Aire Libre",
		descripcion: [
			"Entrenamientos dinámicos para todas las edades",
			"Mejora fuerza, movilidad y resistencia",
			"Disfruta del ejercicio al aire libre",
			"Sesiones grupales motivadoras",
		],
		imagen: "/images/servicios/servicios4.webp",
	},
	{
		titulo: "Rutinas en Casa",
		descripcion: [
			"Entrenamiento pensado para principiantes",
			"Ejercicios fáciles de seguir desde tu hogar",
			"Mejora fuerza, movilidad y resistencia",
			"Flexibilidad para tu rutina diaria",
		],
		imagen: "/images/servicios/servicios7.webp",
	},
	{
		titulo: "Reto de Verano",
		descripcion: [
			"5 semanas de entrenamiento y nutrición",
			"Transforma tu cuerpo",
			"Planes fáciles de seguir",
			"Resultados visibles y motivadores",
		],
		imagen: "/images/servicios/servicios8.webp",
	},
];

export default function Servicios() {
	return (
		<section className="servicios-page">
			<h1>Nuestros Servicios</h1>
			{servicios.map((s, i) => (
				<div key={i} className="servicio-card">
					<div
						className={`servicio-content ${
							i % 2 === 0 ? "normal" : "reverse"
						}`}
					>
						<div className="servicio-text">
							<h2>{s.titulo}</h2>
							<ul>
								{s.descripcion.map((d, idx) => (
									<li key={idx}>{d}</li>
								))}
							</ul>
						</div>
						<div className="servicio-image">
							<img src={s.imagen} alt={s.titulo} />
						</div>
					</div>
				</div>
			))}
		</section>
	);
}
